/** @fileoverview Helper functions for showing how long ago something happened. */

const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const WEEK_MS = 7 * DAY_MS;

/**
 * Describes a past time in words, such as "5 minutes ago" or "yesterday", and switches to the
 * date after a week. Also gives the full date and time for a tooltip. Empty for a bad value.
 */
export const describePastTime = (value: string | undefined, now = Date.now()) => {
  const timestamp = value ? Date.parse(value) : Number.NaN;
  if (Number.isNaN(timestamp)) {
    return { label: '', fullDate: '' };
  }
  const elapsedMs = Math.max(0, now - timestamp);
  const relative = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
  const label =
    elapsedMs < MINUTE_MS
      ? 'just now'
      : elapsedMs < HOUR_MS
      ? relative.format(-Math.floor(elapsedMs / MINUTE_MS), 'minute')
      : elapsedMs < DAY_MS
      ? relative.format(-Math.floor(elapsedMs / HOUR_MS), 'hour')
      : elapsedMs < WEEK_MS
      ? relative.format(-Math.floor(elapsedMs / DAY_MS), 'day')
      : `on ${new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(timestamp)}`;
  const fullDate = new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(timestamp);
  return { label, fullDate };
};
